import { createStore } from 'redux';

import reducers from './reducers';
import middleware from './middleware/middleware';

const store = createStore(reducers, middleware);

export default store;
